<mc-top-bar product="Advanced Equipment Maintenance System" productshort="AEMS">
  <div slot="actions" class="top-bar-actions">
    <!-- Notifications Button with Badge -->
    <div class="notification-wrapper">
      @let notificationCount = notificationService.NewNotificationsCount | async;
      @if (notificationCount && notificationCount > 0) {
        <span class="notification-badge">{{ notificationCount }}</span>
      }
      <mc-button
        variant="plain"
        icon-only
        icon="bell"
        (click)="onBellIconClicked()"
        (keydown)="onBellIconClicked()"
        aria-label="Notifications"></mc-button>
      @if ((notificationService.ShowWorkInProgress | async) === true) {
        <div class="in-progress-indicator">
          <mc-loading-indicator hiddenlabel variant="bar" appearance="primary" fit="small"></mc-loading-indicator>
        </div>
      }
    </div>

    <!-- Profile Tooltip -->
    <mc-tooltip>
      <mc-button slot="trigger" variant="plain" icon-only icon="user-circle" aria-label="User profile"></mc-button>
      <div class="profile-tooltip">
        <div class="profile-name">
          <span>{{ 'Welcome, ' + loggedInUser?.firstName }}</span>
          <span class="m-l-4">{{ loggedInUser?.lastName }}</span>
        </div>
        <div class="profile-details">
          <div>{{ 'Username: ' + loggedInUser?.username }}</div>
          <div>{{ 'Email Address: ' + loggedInUser?.emailAddress }}</div>
          <div>{{ 'Company: ' + loggedInUser?.companyName }}</div>
          <div>{{ 'Roles: ' + loggedInUser?.roles?.join(',') }}</div>
        </div>
      </div>
    </mc-tooltip>

    <!-- Theme Toggle Button -->
    <mc-button
      variant="plain"
      icon-only
      (click)="onToggleThemeClicked()"
      (keydown)="onToggleThemeClicked()"
      [icon]="currentTheme.toString() === 'DARK' ? 'sun' : 'moon'"
      aria-label="Toggle theme"></mc-button>

    <!-- Logout Button -->
    <mc-button
      variant="plain"
      icon-only
      icon="door-arrow-right"
      (click)="onLogoutClicked()"
      (keydown)="onLogoutClicked()"
      aria-label="Logout"></mc-button>
  </div>

  <!-- Notifications Drawer -->
  <mc-drawer [open]="openNotification()" (closed)="onNotificationClosed()" position="right" heading="Notifications">
    <div class="notifications-container">
      @for (notificationHeader of notificationItems | keyvalue: numericCompare; track notificationHeader.key) {
        <div class="notification-date-header">
          {{ notificationHeader.value[0].associatedTaskCreatedAtDateRelative }}
        </div>
        @for (notification of notificationHeader.value; track notification.id) {
          <div class="notification-item-wrapper">
            <app-notification-item [notification]="notification"></app-notification-item>
          </div>
        }
      } @empty {
        <div class="no-notifications">
          <span>You have no notification</span>
        </div>
      }
    </div>
  </mc-drawer>
</mc-top-bar>

<!-- Mobile Menu Overlay -->
<div
  class="menu-overlay"
  (click)="onHamburgerClicked()"
  (keydown)="onHamburgerClicked()"
  [class.menu-overlay-visible]="isSideNavOpen"></div>
